const USER_IS_ADDED = 'User is added';
const USER_IS_DEACTIVATED = 'User is deactivated';

export {
  USER_IS_ADDED,
  USER_IS_DEACTIVATED,
};
